/* =========================================
   FLYY — Scroll reveal
   Auto-applies fade+rise animation to page
   sections as they enter the viewport.
========================================= */
(function () {
  function initFlyyReveal() {
    var skipTypes = [
      "header",
      "footer",
      "announcement",
      "password",
    ];

    var sections = document.querySelectorAll(
      "main .shopify-section, #MainContent .shopify-section"
    );

    if (!sections.length || !("IntersectionObserver" in window)) return;

    sections.forEach(function (section) {
      var id = (section.id || "").toLowerCase();
      var skip = skipTypes.some(function (type) {
        return id.indexOf(type) !== -1;
      });
      if (skip) return;
      section.classList.add("flyy-reveal");
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("flyy-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    document.querySelectorAll(".flyy-reveal").forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFlyyReveal);
  } else {
    initFlyyReveal();
  }

  // Re-run when Shopify editor swaps sections in (theme editor live preview)
  document.addEventListener("shopify:section:load", initFlyyReveal);
})();
